import { jsx } from 'react/jsx-runtime';

var Separator = function() {
    return /*#__PURE__*/ jsx("svg", {
        width: "2",
        height: "23",
        viewBox: "0 0 2 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ jsx("rect", {
            width: "2",
            height: "23",
            fill: "#323130"
        })
    });
};

export { Separator as default };
